import Vue from 'vue'
import app from './app'
export default {
  namespaced: true,
  state: {
    projectName: '',
    projectId: '',
    isFromProjectBar: false,
    // 选择项目下拉展示项目数量
    moreNum: 100,
    dialogVisible: false,
    selectVis: false,
    showForm: '',
    // 财务侧边关联栏是否隐藏
    sideBarShow: false,
    containerType: '0',
    // 财务侧边关联列表
    aboutList: [],
    formData: {
      is_draft: '0'
    },
    list: [],
    Total: 0,
    // 表单搜索
    searchDateSatrt: '',
    searchDateEnd: '',
    search_member_id: '',
    searchInfo: '',
    searchType: '',
    currentPage: 1,
    pageSize: 10,

    // 草稿禁用
    draftDisable: false,
    // 判断是否财务禁用
    isAdmin1: false,
    isAdmin2: false,
    isAdmin3: false,
    isAdmin4: false,
    isAdmin5: false,
    isAdmin6: false,
    // 项目列表
    projectList: [],
    // 项目列表(截取)
    projectListSub: [],
    // 业务结算,项目结算用项目列表
    projectList1: [],
    // 业务结算,项目结算用项目列表(截取)
    projectList1Sub: [],
    // 预设审批人列表
    list3: [],
    sideBarData: {
      // 合同登记
      contract: {
        count: '',
        money: '',
      },
      // 合同用章
      contract_seal: {
        count: '',
        money: '',
      },
      // 合同存档
      contract_archive: {
        count: '',
        money: '',
      },
      // 到账记录
      arrival: {
        count: '',
        money: '',
      },
      // 报销
      reimbursement: {
        count: '',
        money: '',
      },
       // 事前报备
      reportb: {
        count: '',
        money: '',
      },
      // 其他用章审批
      chapter: {
        count: '',
        money: '',
      },
      // 报告用章
      report: {
        count: '',
        money: '',
      },
      // 邮寄
      mail: {
        count: '',
        money: '',
      },
      // 项目专家费
      expert: {
        count: '',
        money: '',
      },
      // 项目结算
      settlement: {
        count: '',
        money: '',
      },
      // 业务结算
      business: {
        count: '',
        money: '',
      },
      external_seal: {
        count: '',
        money: '',
      },
    },
  },
  mutations: {
    // 获取项目财务侧边栏数据
    async getFinanceSildeBarNum(state, project_id) {
      console.log('11state.sideBarData123123asdasdasdasd@#$%^&*', state.sideBarData)

      let params = new FormData()
      params.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      params.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        params.append('device', app.state.deviceInfo)
      } else {
        params.append('device', 'pc')
      }

      params.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      params.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        params.append('project_id', project_id)
      } else {
        params.append('project_id', state.projectId)
      }
      Vue.prototype.$axios({
        method: 'post',
        url: '/api/Finance/get_ffs_relevant',
        data: params,
      }).then((result) => {
        if (result.data.code != 200)
          return this.$message.error(result.data.datas.msg)
        result.data.datas.listInfo.forEach((item) => {
          state.sideBarData[item.code] = item
        })
        console.log('state.sideBarData123123asdasdasdasd@#$%^&*', state.sideBarData)
      })
    },
    setProjectName(state, data) {
      state.projectName = data
    },
    setProjectId(state, data) {
      state.projectId = data
    },
    setIsFromProjectBar(state, data) {
      state.isFromProjectBar = data
    },
    setprojectListSub(state, data) {
      state.projectListSub = data
    },
    setprojectList1Sub(state, data) {
      state.projectList1Sub = data
    },
    // 预设审批人列表
    setList3(state, val) {
      state.list3 = val
    },
    getDialogVisible(state, val) {
      state.dialogVisible = val
    },
    getselectVis(state, val) {
      state.selectVis = val
    },
    getAboutList(state, val) {
      state.aboutList = val
    },
    getSideBarShow(state, val) {
      state.sideBarShow = val
    },
    // containerType赋值
    getContainerType(state, val) {
      state.containerType = val
    },
    // showForm赋值
    getShowForm(state, val) {
      state.showForm = val
    },
    // FormData赋值
    getFormData(state, data) {
      state.formData = data
    },
    // draftDisable赋值
    getDraftDisable(state, data) {
      state.draftDisable = data
    },
    // *1报销列表
    async getReimbursementList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_reimbursement'
      } else {
        urlStr = '/api/Finance/reimbursement'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      console.log('res', res)
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin1 = res.datas.admin_state
    },
    // *1事前报备列表
    async getReportbList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_Reportb'
      } else {
        urlStr = '/api/Finance/reportb'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      console.log('res', res)
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin1 = res.datas.admin_state
    },
    // *2项目结算列表
    async getSettlementList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_settlement'

      } else {
        urlStr = '/api/Finance/settlement'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin2 = res.datas.admin_state
    },
    // *3项目专家费列表
    async getExpertList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_expert'
      } else {
        urlStr = '/api/Finance/expert'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin3 = res.datas.admin_state
    },
    // *4到账记录列表
    async getArrivalList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_arrival'
      } else {
        urlStr = '/api/Finance/arrival'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin4 = res.datas.admin_state
    },
    // *5业务结算
    async getBusinessList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_business'
      } else {
        urlStr = '/api/Finance/business'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin5 = res.datas.admin_state
    },
    // *合同登记
    async getContractList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_contract'
      } else {
        urlStr = '/api/Finance/contract'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('project_type', state.searchType)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin6 = res.datas.admin_state
    },

    // *合同预存
    async getContractList1(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Financer/ass_contract'
      } else {
        urlStr = '/api/Financer/contract'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('project_type', state.searchType)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin6 = res.datas.admin_state
    },


    // 表单搜索赋值
    assignmentSearchDateSatrt(state, data) {
      state.searchDateSatrt = data
    },
    assignmentSearchDateEnd(state, data) {
      state.searchDateEnd = data
    },
    assignmentSearch_member_id(state, data) {
      state.search_member_id = data
    },
    assignmentSearchInfo(state, data) {
      state.searchInfo = data
    },
    assignmentSearchType(state, data) {
      state.searchType = data
    },
    assignmentCurrentPage(state, data) {
      state.currentPage = data
    },
    assignmentPageSize(state, data) {
      state.pageSize = data
    },

    // projectList赋值
    assignmentProject(state, data) {
      state.projectList = data
    },
    // projectList1赋值
    assignmentProject1(state, data) {
      state.projectList1 = data
    },
    // 清空列表
    emptyList(state) {
      state.list = []
    },
    // 清空列表
    emptyFormData(state) {
      state.formData = {
        is_draft: '0'
      }
    },
  },
  actions: {

  },
  getters: {
    finance_stage: (state) => {
      if (state.showForm == 'showFormAdd' || state.showForm == 'showFormHandle') {
        return 'reimbursement'
      }
      if (state.showForm == 'showFormReportbAdd' || state.showForm == 'showFormReportbHandle') {
        return 'reportb'
      }
      if (state.showForm == 'showFormClearAdd' || state.showForm == 'showFormClearHandle' || state.showForm == 'showFormClearHandle1' || state.showForm == 'showFormClearHandle1') {
        return 'settlement'
      }
      if (state.showForm == 'showFormZhuanAdd' || state.showForm == 'showFormZhuanHandle') {
        return 'expert'
      }
      if (state.showForm == 'showFormEndAdd' || state.showForm == 'showFormEndHandle') {
        return 'arrival'
      }
      if (state.showForm == 'showFormBusinessAdd' || state.showForm == 'showFormBusinessHandle') {
        return 'business'

      }
      if (state.showForm == 'showFormContractAdd' || state.showForm == 'showFormContractHandle') {
        return 'contract'
      }
    },
  },
}
